import React__default from 'react';
import { P2 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { AutoshipLogo } from '../autoship-logo/AutoshipLogo.js';
import styles from './MiniSummary.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';
import { TitleWithEdit } from '../../preview/title-with-edit/TitleWithEdit.js';

const MiniSummary = (props) => {
    const goToOffer = () => {
        if (props.cta === 'cart')
            props.offerElement?.scrollIntoView();
    };
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const boxStyle = props.cta === 'cart' && !props.errorTranslation
        ? `${styles.miniSummaryBox} ${styles.clickable}`
        : `${styles.miniSummaryBox}`;
    return (React__default.createElement("div", { className: boxStyle, onClick: () => {
            if (props.cta === 'cart' && !props.errorTranslation) {
                goToOffer();
            }
        } },
        React__default.createElement("div", { className: styles.summaryContent },
            props.interval === 0 ? React__default.createElement(TitleWithEdit, { logoSize: 'small', noIntervalSelected: true })
                : React__default.createElement(AutoshipLogo, { className: styles.inlineLogo, logoSize: 'small' }),
            React__default.createElement(P2, { className: styles.text }, !props.errorTranslation && props.products
                ? ` ${t(props.products == 1
                    ? 'checkout.cart-offer.mini-summary-products_one'
                    : 'checkout.cart-offer.mini-summary-products_other', { count: props.products })} · ${props.interval ?
                    t(props.interval == 1
                        ? 'checkout.common.delivery-interval-new.week-interval_one'
                        : 'checkout.common.delivery-interval-new.week-interval_other', { postProcess: 'interval', count: props.interval })
                    : t('checkout.common.delivery-interval-new.no-delivery-scheduled')}`
                : props.errorTranslation),
            props.cta === 'cart' && !props.errorTranslation && (React__default.createElement(P2, { bold: true, className: styles.cta }, props.interval ? t('checkout.common.edit') : t('checkout.common.delivery-interval-new.schedule'))))));
};

export { MiniSummary };
//# sourceMappingURL=MiniSummary.js.map
